import { Component } from '@angular/core';
import { TrpcService } from '../../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { TennatAccountContactInfo } from '../../../../../express-tRPC/src/api/tenants/types-generic';
import { MonthlyInvoice } from '../../../../../express-tRPC/src/api/monthly_invoices/types';
import { Title } from "@angular/platform-browser";
import { LotSettings } from '../../../../../express-tRPC/src/api/lot-settings/types';
import {environment} from '../../../environments/environment';
import { Identifier, SUREPARKSubscriber } from '../../../../../express-tRPC/src/shared/types';

@Component({
  selector: 'app-terminate-contacts',
  templateUrl: './terminate-contacts.component.html',
  styleUrl: './terminate-contacts.component.scss'
})
export class TerminateContactsComponent {
  version = environment.version;
  activeFile = environment.activeFile;

  isProfileContactsLoading: boolean = false;
  allProfileContacts: TennatAccountContactInfo[] = [];
  allProfileContactsCount: number = 0;

  selectedContacts!: TennatAccountContactInfo[] | null;

  isProfilesLoading: boolean = false;
  allMonthlyProfiles: MonthlyInvoice[] = [];
  allMonthlyProfilesCount: number = 0;

  totalMonthlyProfilesContactFetched: number = 0;
  monthlyProfilesContactFetchedFailed: MonthlyInvoice[] = [];

  profileContactFetchedPercent: number = 0;
  ac = new AbortController();

  totalProfileContactDeleted: number = 0;
  profileContactDeletedPercent: number = 0;
  profileContactDeleteFailed: number = 0;

  currentLocation: string = '';

  locationSettings!: LotSettings;
  loadingSettings: boolean = false;

  allSureparkMembers: SUREPARKSubscriber[] = [];
  // Indicates whether or not SUREPARK contacts will be marked as inactivate when ParkPro account is deleted.
  disableSureparkContact: boolean = true;

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.getSettings();
    this.trpcService.currentLocationObservable.subscribe((location: string) => {
      this.currentLocation = location;
      this.titleService.setTitle(`Remove Expired Contacts | ${location}`);
    })
  }

  async getSettings() {

    this.loadingSettings = true;

    let locationSettingsAny: any = await this.trpcService.trpc.settings.get.query().catch((error: any) => {
        this.loadingSettings = false;
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });

    this.locationSettings = locationSettingsAny as LotSettings;
    this.loadingSettings = false;

    await this.loadSureparkMembers();

  }

  async getAllMonthlyProfiles(): Promise<void> {
    this.isProfilesLoading = true;

    let allMonthlyProfilesResult: any = await this.trpcService.trpc.surepark.getAllMonthlyInvoiceProfiles.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'general-message'
      });
    });

    if(allMonthlyProfilesResult) {
      this.allMonthlyProfiles = allMonthlyProfilesResult;
      this.allMonthlyProfilesCount = allMonthlyProfilesResult.length;
      this.loadProfileContacts();
    }

    // this.isProfilesLoading = false;
  }

  async loadProfileContacts() {
    await new Promise((resolve, reject) => {
      this.allMonthlyProfiles.forEach(async (monthlyProfile: MonthlyInvoice, index: number) => {
        await this.getProfileContacts(monthlyProfile);
        if (index == (this.allMonthlyProfiles.length - 1)) {
          resolve(true);
          this.isProfilesLoading = false;

          this.messageService.add({
            severity: "info",
            detail: "Tip: Press Tab and Spacebar to select the next contact in the list",
            key: 'tip-msg',
            closable: false
          });
      }
      })
    })
  }

  async loadSureparkMembers() {

    let sureparkMembersResult: any = await this.trpcService.trpc.surepark.getSureparkGroupsSubscribers.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'general-message'
      });
    });

    if(sureparkMembersResult) {
      this.allSureparkMembers = sureparkMembersResult;
    }
    await this.getAllMonthlyProfiles();
  }

  async getProfileContacts(monthlyProfile: MonthlyInvoice): Promise<void> {

    await this.trpcService.trpc.surepark.getAllProfileContacts.query({suite: String(monthlyProfile.suite), account: String(monthlyProfile.account)}, {signal: this.ac.signal}).then((allProfileContactsResult) => {
      if(allProfileContactsResult) {

        //To display rate discription, Check contact rate code with rates that is present in both ppro and surepark
        allProfileContactsResult.map((contact: TennatAccountContactInfo) => {
          const matchedRateIndex = this.locationSettings.ratesReport?.approved.findIndex((rate: any) => rate.parkproCode == contact.rate);
          if(matchedRateIndex !== -1) {
            contact.monthly_profile_details['contact_rate_description'] = this.locationSettings.ratesReport?.approved[matchedRateIndex].parkproDescription;
          }

          const matchedSureparkContactIndex = this.allSureparkMembers.findIndex((member: SUREPARKSubscriber) => {
            if (member.groupId == contact.monthly_profile_details.parkingDeviceGroupID && member.identifiers?.length) {
              const matchIndex = member.identifiers.findIndex((identifier: Identifier) => identifier.type == "Hid");
              if (matchIndex !== -1) {
                const [facility_code, keycard] = member.identifiers[matchIndex].identifierNumber?.split("/")
                return (keycard == contact.keycards);
              }
            }
            return false;
          });

          if(matchedSureparkContactIndex !== -1) {
            console.log(contact.keycards)
            contact.surepark_member_details = this.allSureparkMembers[matchedSureparkContactIndex];
          }

          return contact;
        })
        this.allProfileContacts = this.allProfileContacts.concat(allProfileContactsResult);
      }
      this.totalMonthlyProfilesContactFetched += 1;
      this.profileContactFetchedPercent = Math.round(100 / this.allMonthlyProfiles.length * this.totalMonthlyProfilesContactFetched);

    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: "Unable to load contacts of profile ("+monthlyProfile.suite +" - "+monthlyProfile.account+")",
        key: 'profile-contact-error'
      });
      this.monthlyProfilesContactFetchedFailed.push(monthlyProfile);
    });

  }

  cancelProfileContactProcess() {
    this.ac.abort();
  }

  async deleteSelectedContacts(action?:string): Promise<void> {
    if(action == 'all') {
      this.selectedContacts = this.allProfileContacts;
    }

    //Billing Contact should not get delete
    this.selectedContacts = this.selectedContacts?.filter((contact: TennatAccountContactInfo) => !contact.monthly_profile_details?.is_billing_contact) || [];

    if(!this.selectedContacts?.length) {
      this.messageService.add({
        severity: "error",
        detail: "Please select contact(s) to terminate.",
      });
      return;
    }
    this.isProfileContactsLoading = true;
    this.totalProfileContactDeleted = 0;
    this.profileContactDeletedPercent = 0;
    this.profileContactDeleteFailed = 0;

    for (const contact of this.selectedContacts!) {
      const tenantContact: TennatAccountContactInfo = contact;
      await this.deleteTenantContact(tenantContact);
    }

    this.messageService.add({
      severity: "success",
      detail: "Contact(s) has been deleted successfully.",
    });

    setTimeout(() => {
      this.selectedContacts = [];
      this.isProfileContactsLoading = false;
    }, 3000);

    /*
    this.isProfileContactsLoading = true;
    this.trpcService.trpc.surepark.deleteProfileContacts.mutate(this.selectedContacts || []).then(async (response: any) => {
      this.messageService.add({
        severity: "success",
        detail: "Contact(s) has been deleted successfully.",
      });

      const selectedContacts = Object.assign([], this.selectedContacts);
      this.allProfileContacts = this.allProfileContacts.filter((contact: TennatAccountContactInfo, index: number) => {
        const matcheIndex = selectedContacts?.findIndex((contactInfo: TennatAccountContactInfo) => JSON.stringify(contactInfo) == JSON.stringify(contact));
        return matcheIndex === -1;
      });
      this.selectedContacts = [];
      this.isProfileContactsLoading = false;

    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
      this.isProfileContactsLoading = false;
    });*/
  }

  async deleteTenantContact(tenantContact: TennatAccountContactInfo) {

    await this.trpcService.trpc.surepark.deleteProfileContacts.mutate({contacts: tenantContact, disableSureparkContact: this.disableSureparkContact}).then(async (response: any) => {

      const matchedIndex = this.allProfileContacts.findIndex((contact: TennatAccountContactInfo, index: number) => {
        return JSON.stringify(tenantContact) == JSON.stringify(contact);
      });

      if(matchedIndex !== -1) {
        this.allProfileContacts.splice(matchedIndex, 1);
      }

      this.totalProfileContactDeleted += 1;
      this.profileContactDeletedPercent = Math.round(100 / (this.selectedContacts?.length || 0) * this.totalProfileContactDeleted);

    }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'delete-profile-contact-error'
      });
      this.profileContactDeleteFailed += 1;
    });
  }
}
